import { ValidatorFn, AbstractControl } from '@angular/forms';

/**
 * Validador de email más estricto que Validators.email
 * Valida que el email tenga el formato correcto: usuario@dominio.extension
 * Ejemplo válido: test@test.com
 * Ejemplo inválido: test@testcom (falta el punto)
 */
export function validEmailValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (!control.value || control.value === '') {
      return null; // Si está vacío, no validar (dejar que required lo maneje)
    }

    let email = '';
    // Si el valor es un objeto con propiedad 'values' (campos dentro de tipo 48)
    if (control.value && typeof control.value === 'object' && control.value.hasOwnProperty('values')) {
      email = control.value.values;
    } else {
      email = control.value;
    }

    // Convertir a string si no lo es
    if (typeof email !== 'string') {
      email = String(email);
    }

    // Regex más estricto para validar email
    // Requiere: usuario@dominio.extension (al menos un punto después del @)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email.trim())) {
      return {
        'validEmail': true
      };
    }

    return null;
  };
}

